import { Injectable } from '@angular/core';
import { GlobalService } from './global.service';
import { globals } from '../globals';
import { HttpClient, HttpParams } from '@angular/common/http';
import { VoucherAutomatico } from '../models/voucher-automativo';

@Injectable({
  providedIn: 'root'
})
export class VoucherAutomaticoService {

  constructor(
    private globalService: GlobalService,
    private http: HttpClient
  ) { }

  salvar(voucher: VoucherAutomatico) {
    return this.http.post(globals.apiUrl + '/api/VoucherAutomatico/Salvar', voucher);
  }

  consultarPorId(id: number) {
    return this.http.get<VoucherAutomatico>(globals.apiUrl + '/api/VoucherAutomatico/Buscar', {
      params: new HttpParams().set('id', id.toString())
    });
  }

  listarTodos() {
    return this.http.get<VoucherAutomatico[]>(globals.apiUrl + '/api/VoucherAutomatico/ListarTodos');
  }

  consultarComPaginacao(descri, paginaAtual, qtdRegistros, campoOrdenacao, asc_desc) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', asc_desc)
      .set('descri', descri ? descri : '');

    return this.http.get<any>(globals.apiUrl + '/api/VoucherAutomatico/ListaPag', { params: parametros });
  }

  excluir(id: number) {
    return this.http.delete(globals.apiUrl + '/api/VoucherAutomatico/Excluir', { params: new HttpParams().set('id', id.toString())});
  }
}
